import config from '../../../config'
import axios from 'axios'

const validateToken = async ({ tokenId }) => {
    const response = await axios.get(config.API_BASE_URL + '/magicpoints/validate-token?token_id=' + tokenId)

    return response
}

export default validateToken